import ErrorBoundary from 'shared/components/ErrorBoundary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion  from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { removeHTML, removeStyleHTML } from 'shared/utils/htmlHelpers';
import styles from './styles.css';

const Description = props => {
	const { shortDescription, fullDescription } = props;
	// format product description html
	const dscrMarkupShort = removeStyleHTML(removeHTML(shortDescription));
	const dscrMarkupFull = removeStyleHTML(removeHTML(fullDescription));

	if (shortDescription != null && shortDescription !== '') {
		return (
			<ErrorBoundary>
				<div className={styles['product-expandable-spacer']}>
					<Accordion>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography variant="subtitle2">Description</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<div
								className={styles['product-description']}
								// eslint-disable-next-line react/no-danger
								dangerouslySetInnerHTML={{ __html: dscrMarkupShort }}
							/>
						</AccordionDetails>
					</Accordion>
				</div>
			</ErrorBoundary>
		);
	} else if (fullDescription !== null && fullDescription !== '') {
		return (
			<ErrorBoundary>
				<div className={styles['product-expandable-spacer']}>
					<Accordion>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Typography variant="subtitle2">Full Description</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<div
								className={styles['product-full-description']}
								// eslint-disable-next-line react/no-danger
								dangerouslySetInnerHTML={{ __html: dscrMarkupFull }}
							/>
						</AccordionDetails>
					</Accordion>
				</div>
			</ErrorBoundary>
		);
	}
	return null;
};

Description.defaultProps = {
	shortDescription: null,
	fullDescription: null,
};

Description.propTypes = {
	shortDescription: PropTypes.string,
	fullDescription: PropTypes.string,
};

export default Description;
